// extracted by mini-css-extract-plugin
export default {"PaymentForm":"PaymentForm_PaymentForm__S51-I"};